module.exports = __webpack_public_path__ + "img/f-thermometer-img2-2.2e153321.png";